// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminGenerateJwsTokenResponse

export type AdminGenerateJwsTokenApiResponse = {
	token: string;
	jwks_url: string;
};

export type AdminGenerateJwsToken = {
	token: string;
	jwks_url: string;
};

export function hydrateAdminGenerateJwsToken(data: AdminGenerateJwsTokenApiResponse): AdminGenerateJwsToken {
	return { ...data };
}